import { useState } from 'react';

export default function useIndicarParceriaModal() {
  const [textoCopiado, setTextoCopiado] = useState(false);
  const [modalAbertoMsg, setModalAbertoMsg] = useState(false);
  const link = 'https://one7.app/';

  async function copiarLink() {
    if (navigator.clipboard?.writeText) {
      try {
        await navigator.clipboard.writeText(link);
      } catch {
        setModalAbertoMsg(true);
      }

      setTextoCopiado(true);
    }
  }

  return {
    link,
    copiarLink,
    textoCopiado,
    modalAbertoMsg,
    setModalAbertoMsg
  };
}
